<div class="work-card work-card--is-clickable no-padding margin-bottom-12">
  @if (news().newsImage; as newsImage) {
    <div class="mitteilungen-list-item-image">
      <img [src]="newsImage.fileSrcOptimized | prependServerToFileSrc" [alt]="'BILD' | translate">
    </div>
  }
  <div class="padding-16">
    <p><small>{{ news().showFrom | formatDate }}</small></p>
    <h1>{{ news().title }}</h1>
    @if (showText()) {
      <p [innerHTML]="news().text"></p>
    }
  </div>
</div>
